<template>

 <!-- Ele vive, Ele reina, Ele é Deus e senhor -->
  <div id="app">
    <div id="conteudo">

      <div class="d-flex" style="height: 100%;" id="wrapper">
        <sider></sider>
        <!-- Conteúdo principal -->
        <div class="flex-grow-1">
          <!-- Top navbar -->
          <mcabecalho></mcabecalho>

          <!-- Conteúdo -->
          <div class="container-fluid mt-4">
            <router-view />
            <GlobalLoading />
          </div>
        </div>
      </div>
    </div>


    <div id="login">
      <section class="vh-100" style="background-color: rgb(164 152 197);">
        <div class="container py-5 h-100">
          <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col col-xl-10">
              <div class="card" style="border-radius: 1rem; background-color: #d1c6e4;">
                <div class="row g-0">
                  <div class="col-md-6 col-lg-5 d-none d-md-block">
                    <img src="../src/assets/side.png"
                      alt="login form" class="img-fluid" style="border-radius: 1rem 0 0 1rem;" />
                  </div>
                  <div class="col-md-6 col-lg-7 d-flex align-items-center">
                    <div class="card-body p-4 p-lg-5 text-black">

                      <form>

                        <div class="d-flex align-items-center mb-3 pb-1">
                          <i class="fas fa-cubes fa-2x me-3" style="color: #ff6219;"></i>
                           <img src="../src/assets/loginimg.png" id="loginimg" alt="login form" class="img-fluid" style="border-radius: 1rem 0 0 1rem;" />
                        </div>

                        

                        <div data-mdb-input-init class="form-outline mb-4" style="margin-top: 30px;">
                          <input v-model="vid" style="background-color: transparent; " type="number" id="form2Example27"
                            class="form-control form-control-lg" />
                          <label class="form-label" for="form2Example27">Código de acesso da empresa</label>
                        </div>

                        <div data-mdb-input-init class="form-outline mb-4">
                          <input type="email" style="background-color: transparent;" v-model="vlogin" id="form2Example17"
                            class="form-control form-control-lg" />
                          <label class="form-label" for="form2Example17">Login</label>
                        </div>

                        <div data-mdb-input-init class="form-outline mb-4">
                          <input v-model="vsenha" style="background-color: transparent;" type="password" id="form2Example27"
                            class="form-control form-control-lg" />
                          <label class="form-label" for="form2Example27">Senha</label>
                        </div>
                        
                        <div class="mb-4">
                          <button @click.prevent="mtdlogar()" style="width: 100%;" data-mdb-button-init data-mdb-ripple-init class="btn btn-dark btn-lg btn-block"
                            type="button">Login</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>


</template>

<script>
// ☧  ✟
//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);
//Creio em ti Senhor e Deus meu, porque tu és a minha força e o meu refúgio. (Salmo 31:14-15);

import sider from '@/components/sider.vue'
import mcabecalho from '@/components/mcabecalho.vue'
import util from '../src/util'

export default {
  name: 'app',
  components: {
    sider,
    mcabecalho
  },
  data(){
    return {
       vid: '',
       vlogin: '',
       vsenha: ''
    }
  },
  /**
   * 
   */
  methods: {
    definessessao(dadosusuario) {
      localStorage.setItem('dadosusuario', JSON.stringify(dadosusuario));
      location.reload();
    },
    isArrayOrObject(value) {
      return value !== null && typeof value === 'object';
    },
    mtdlogar() {
      var vself = this;

      let dadoslogin = {
        'usuario': this.vlogin,
        'senha': this.vsenha
      }

      let parametros = [

        { parametro: 'op', valor: 'logar' },
        { parametro: 'idempresa',  valor: vself.vid },
        { parametro: 'dadoslogin', valor: JSON.stringify(dadoslogin) },

      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor+'/controller/rotinalogin.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data.msg)) {
          vself.definessessao(response.data);
        } else {
          util.notif('error', 'Informação!', response.data.msg.substring(4));
          //alert(response.data.msg.substring(4));
        }
      }).catch(function (response) {

      });
    },
  },
  mounted() {

    console.log('window.$loading existe?', !!window.$loading)

    setTimeout(() => {
      $('#wrapper').hide();
    }, 100);


    const dadosusuario = localStorage.getItem('dadosusuario');

    if (dadosusuario) {
      let jsondados = JSON.parse(dadosusuario);
      if (this.isArrayOrObject(jsondados)) {

        this.$store.commit('definelogin', jsondados);

        $('#login').hide();
        $('#conteudo').show();
      }
    } else {
      $('#conteudo').hide();
      $('#login').show();
    }

  }
}

</script>
<style lang="scss">
html {
  height: 100%;
}

body {
  height: 100%;
}

#app {
  height: 100%;
}

.card {
  border-radius: 25px !important;
}

.card-body {
  border-radius: 25px !important;
}

.card-header {
  border-radius: 25px !important;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #444;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #cbc8d0;
  border-radius: 5px !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: none !important;
  border-bottom: 1px solid #13534a !important;
}

.btn-info {
  background-color: #13534a !important;
  color: #fdfdfd !important;

  border: #13534a !important;
}

.btn-warning {
  background-color: #13534a !important;
  color: #fdfdfd !important;

  border: #13534a !important;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  display: block;
  padding-left: 8px;
  padding-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none !important;
  border-bottom: 1px solid #13534a !important;
}
.select2-container--bootstrap .select2-selection--single {
    height: calc(1.5em + 0.75rem + 2px);
    line-height: 1.5;
    // /* padding: 0.375rem 1.5rem 0.375rem 0.75rem; 
    padding-top: 11px !important;
    
    background-color: transparent !important;
    border: none !important;
}
.select2-container--bootstrap .select2-selection--single .select2-selection__rendered {
    color: #495057;
    padding: 0px !important;
    padding-top: 3px !important;
    margin: 0px !important;
    padding-left: 9px !important;
    width: 100% !important;
    position: relative !important;
    border-radius: 6px !important;
}

.select2-container--bootstrap .select2-selection--single {
    height: calc(1.5em + 0.75rem + 2px);
    line-height: 1.5;
    /* padding: 0.375rem 1.5rem 0.375rem 0.75rem; */
    padding: 10px 0px 0px 0px !important;
}

#loginimg {
  border-radius: 1rem 0px 0px 1rem;
    /* height: 270px; */
    /* width: 278px; */
    width: 30%;
    height: auto;
    position: relative;
    /* top: 0px; */
    left: 166px;
  
    justify-content: center;
}

.active-page {
    background-color: #13534a !important;
    border: 1px solid #13534a !important;
    color: white;
}

</style>
